import { useTheme } from '@approvalmax/theme';
import { Box, Flex } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useMedia } from 'react-use';

export const Loading = memo(() => {
    const { theme } = useTheme();
    const isSmallScreen = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);

    return (
        <Flex justifyContent='center'>
            <Box width={isSmallScreen ? undefined : theme.container.content.small}>
                <Flex direction='column'>
                    <Flex direction='column' spacing='8'>
                        <Skeleton width={250} height={24} />

                        <Skeleton width={100} height={22} />
                    </Flex>

                    <Skeleton height={50} />

                    <Flex direction='column' spacing='2'>
                        <Skeleton height={50} />

                        <Skeleton height={124} />

                        <Skeleton height={154} />

                        <Skeleton height={112} />
                    </Flex>
                </Flex>
            </Box>
        </Flex>
    );
});

Loading.displayName = 'Loading';
